module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/eye_open-ec46562ed814e93c1d442879c0085186.svg&quot;;"